export const ActivityStatus = {
  Complete: "complete",
  Incomplete: "incomplete",
  Locked: "locked",
};

const ActivityStatusMap = new Map();
ActivityStatusMap.set(ActivityStatus.Complete, {
  key: "complete",
  label: "Complete",
  description: "The activity has been successfully completed",
  icon: "fa-solid fa-circle-check",
});
ActivityStatusMap.set(ActivityStatus.Incomplete, {
  key: "incomplete",
  label: "Incomplete",
  description: "The activity has not been completed yet",
  icon: "fa-regular fa-circle",
});
ActivityStatusMap.set(ActivityStatus.Locked, {
  key: "locked",
  label: "Locked",
  description: "The activity is locked due to unmet prerequisites",
  icon: "fa-solid fa-lock",
});

export function getActivityStatus(status) {
  return ActivityStatusMap.get(status);
}

export function getActivityStatusIcon(status) {
  const statusInfo = ActivityStatusMap.get(status);
  return statusInfo
    ? statusInfo.icon
    : ActivityStatusMap.get(ActivityStatus.Incomplete).icon;
}

export function getAllActivityStatuses() {
  return [...ActivityStatusMap.values()];
}

export const AllActivityStatuses = Object.values(ActivityStatus);
